export default "__VITE_ASSET__5Mc$F9gD__"